// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608241421/js/" + chunkId + "." + {"44":"2f23f0b4","225":"583e632c","481":"5d16d112","486":"e4842769","770":"3e5bb14a"}[chunkId] + ".0.8659222826703518.chunk.js";
};